<template>
  
  <div 
    ref   = "overlay_container" 
    class = "overlay_container"
  >

    <!-- Center -->
    <div 
      class   = "center"
      v-if    = "video.overlays.length > 0"
    >
      +
    </div>

    <!-- Action Safe -->
    <div 
      v-if      = "video.overlays.includes('action_safe')"
      class     = "generic actionSafe region"
      :style    = "actionSafeStyle"
    >
      <div class="label">Action Safe</div>
    </div>

    <!-- Title Safe -->
    <div 
      v-if      = "video.overlays.includes('title_safe')"
      class     = "generic titleSafe region"
      :style    = "titleSafeStyle"
    >
      <div class="label">Title Safe</div>
    </div>

    <!-- 16x9 Action Safe -->
    <div 
      v-if      = "video.overlays.includes('action_safe_16x9')"
      class     = "actionSafe region"
      :style    = "actionSafe16x9Style"
    >
      <div class="label">16:9 Center Cut Action Safe</div>
    </div>

    <!-- 16x9 Title Safe -->
    <div 
      v-if      = "video.overlays.includes('title_safe_16x9')"
      class     = "titleSafe region"
      :style    = "titleSafe16x9Style"
    >
      <div class="label">16:9 Center Cut Title Safe</div>
    </div>

    <!-- 4x3 Action Safe -->
    <div 
      v-if      = "video.overlays.includes('action_safe_4x3')"
      class     = "actionSafe region"
      :style    = "actionSafe4x3Style"
    >
      <div class="label">4:3 Center Cut Action Safe</div>
    </div>

    <!-- 4x3 Title Safe -->
    <div 
      v-if      = "video.overlays.includes('title_safe_4x3')"
      class     = "titleSafe region"
      :style    = "titleSafe4x3Style"
    >
      <div class="label">4:3 Center Cut Title Safe</div>
    </div>

    <!-- 1.85:1 Action Safe -->
    <div 
      v-if      = "video.overlays.includes('action_safe_1_85x1')"
      class     = "actionSafe region"
      :style    = "actionSafe185Style"
    >
      <div class="label">1.85:1 Center Cut Action Safe</div>
    </div>

    <!-- 1.85:1 Title Safe -->
    <div 
      v-if      = "video.overlays.includes('title_safe_1_85x1')"
      class     = "titleSafe region"
      :style    = "titleSafe185Style"
    >
      <div class="label">1.85:1 Center Cut Title Safe</div>
    </div>

  </div>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

// #endregion Imports

export default {

  // #region Properties

  name: 'Overlays',
  data() {
    return {
      containerWidth:  0,
      containerHeight: 0,
      sizeObserver:    undefined
    }
  },
  computed: {
    ...mapState([
      'video'
    ]),
    actionSafeStyle() {
      let height = this.containerHeight * 0.9;
      let width = this.containerWidth * 0.9;

      return this.generateOverlayStyle(width, height);
    },
    titleSafeStyle() {
      let height = this.containerHeight * 0.8;
      let width = this.containerWidth * 0.8;

      return this.generateOverlayStyle(width, height);
    },
    actionSafe16x9Style() {
      let height = this.containerHeight * 0.9;
      let width = height * (16/9);

      if (width > this.containerWidth) {
        width = this.containerWidth * 0.9;
        height = width / (16/9);
      }

      return this.generateOverlayStyle(width, height);
    },
    titleSafe16x9Style() {
      let height = this.containerHeight * 0.8;
      let width = height * (16/9);

      if (width > this.containerWidth) {
        width = this.containerWidth * 0.8;
        height = width / (16/9);
      }

      return this.generateOverlayStyle(width, height);
    },
    actionSafe4x3Style() {
      let height = this.containerHeight * 0.9;
      let width = height * (4/3);

      if (width > this.containerWidth) {
        width = this.containerWidth * 0.9;
        height = width / (4/3);
      }

      return this.generateOverlayStyle(width, height);
    },
    titleSafe4x3Style() {
      let height = this.containerHeight * 0.8;
      let width = height * (4/3);

      if (width > this.containerWidth) {
        width = this.containerWidth * 0.8;
        height = width / (4/3);
      }

      return this.generateOverlayStyle(width, height);
    },
    actionSafe185Style() {
      let height = this.containerHeight * 0.9;
      let width = height * (1.85);

      if (width > this.containerWidth) {
        width = this.containerWidth * 0.9;
        height = width / (1.85);
      }

      return this.generateOverlayStyle(width, height);
    },
    titleSafe185Style() {
      let height = this.containerHeight * 0.8;
      let width = height * (1.85);

      if (width > this.containerWidth) {
        width = this.containerWidth * 0.8;
        height = width / (1.85);
      }

      return this.generateOverlayStyle(width, height);
    }
  },

  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    this.updateContainerDimensions();

    window.addEventListener('fullscreenchange', this.updateContainerDimensions);
    this.sizeObserver = new ResizeObserver(this.updateContainerDimensions).observe(this.$refs.overlay_container);
  },

  beforeDestroy() {
    window.removeEventListener('fullscreenchange', this.updateContainerDimensions);
    if (this.sizeObserver) {
      this.sizeObserver.unobserve(this.$refs.overlay_container);
    }
  },

  // #endregion Life-Cycle

  // #region Operations

  methods: {

    updateContainerDimensions() {
      if (this.$refs.overlay_container) {
        this.containerWidth = this.$refs.overlay_container.clientWidth;
        this.containerHeight = this.$refs.overlay_container.clientHeight;
      } else {
        this.containerWidth = 0;
        this.containerHeight = 0;
      }
    },

    generateOverlayStyle(width, height) {
      return {
        height: `${height}px`,
        width:  `${width}px`,

        top:  `${((this.containerHeight - height) / 2)}px`,
        left: `${((this.containerWidth - width) / 2)}px`,
      }
    }

  }

  // #endregion Operations

}

</script>

<style lang="scss" scoped>

.overlay_container {
  position:       relative;

  .region {
    position:       absolute;
    border:         3px solid white;

    &.actionSafe {
      border-color:   rgba(0, 0, 255, 0.3);
      color:          rgba(0, 0, 255);
    }

    &.titleSafe {
      border-color:   rgba(0, 255, 0, 0.3);
      color:          rgba(0, 255, 0);
    }

    &.generic {

      &.actionSafe {
        border-color:   rgba(255, 255, 0, 0.3);
        color:          rgba(255, 255, 0);
      }

      &.titleSafe {
        border-color:   rgba(255, 0, 0, 0.3);
        color:          rgba(255, 0, 0);
      }

    }

    .label {
      padding:      4px 8px;
      animation:    fadeOut ease-in 5s forwards;
    }

  }

  .center {
    position:   absolute;
    top:        50%;
    left:       50%;
    transform:  translateY(-50%) translateX(-50%);
    color:      rgba(255, 255, 0, 0.2);
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>